/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  REGISTER_USER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.tribe.register.user',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'REGISTER_USER' },
      },
    },
    REGISTER_USER: {
      invoke: {
        id: 'registerUser',
        src: 'registerUser',
        onDone: {
          target: 'REGISTER_USER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'REGISTER_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    REGISTER_USER_SUCCESS: {
      on: {
        START: { target: 'REGISTER_USER' },
      },
    },
    REGISTER_USER_FAILED: {
      on: {
        START: { target: 'REGISTER_USER' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
